import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GetRoles, GetRolesFailed, GetRolesSuccess } from '../actions/roles.actions';
import { RolesService } from '../services/roles.service';

@Injectable()
export class RolesEffects {
  constructor(
    private actions$: Actions,
    private rolesService: RolesService,
  ) {}

  getRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetRoles),
      switchMap(() =>
        this.rolesService.getRoles().pipe(
          map((res) => GetRolesSuccess({ roles: res })),
          catchError((error) => of(GetRolesFailed(error))),
        ),
      ),
    ),
  );
}
